/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters, {
	type NotificationLogsPageQuery,
} from './__generated__/NotificationLogsPageQuery.graphql.ts';

type AccountId = string;

type Queries = { notificationLogs: NotificationLogsPageQuery };
type ExtraProps = {
	accountId: AccountId | null;
};

type NotificationLogsEntryPointComponent = EntryPointComponent<Queries, {}, {}, ExtraProps>;

export const notificationLogsEntryPoint: EntryPoint<
	NotificationLogsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForUserVisible<NotificationLogsEntryPointComponent>(
		/* webpackChunkName: "async-notifications-log" */ './NotificationLogs.tsx',
		{
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => ({
		queries: {
			notificationLogs: {
				options: {
					fetchPolicy: 'network-only' as const,
				},
				parameters,
				variables: {
					cloudId: tenantContext.cloudId,
					projectIds: context?.query?.projectId,
					notificationType: 'INTERNAL_NOTIFICATION',
					notificationActionType: 'USER_INVITE',
					recipientId: '',
				},
			},
		},
		extraProps: {
			accountId: tenantContext.atlassianAccountId,
		},
	}),
});
